export enum FlowType {
  Standard = 'standard',
  Tickets = 'tickets',
  Voucher = 'voucher',
  Birthday = 'birthday',
  GiftCard = 'giftcard',
}
